module.exports = __webpack_public_path__ + "img/content_pic02.66f6136e.jpg";